import script from "./VideoWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoWidget.vue?vue&type=script&setup=true&lang=ts"

import "./VideoWidget.vue?vue&type=style&index=0&id=ddd8f6f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddd8f6f0"]])

export default __exports__